// Colour buttons on the cart "Add a 2nd / 3rd" card. Delegated: the cart drawer re-renders its HTML after every change.
(() => {
  if (window.__cartMultibuy) return;
  window.__cartMultibuy = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-multibuy-variant]');
    if (!btn) return;
    const card = btn.closest('.cart-multibuy');
    card.querySelectorAll('[data-multibuy-variant]').forEach((b) => b.setAttribute('aria-pressed', String(b === btn)));
    const id = card.querySelector('[data-multibuy-id]');
    if (id) id.value = btn.getAttribute('data-multibuy-variant');
    const img = card.querySelector('[data-multibuy-image]');
    if (img && btn.dataset.img) {
      img.removeAttribute('srcset');
      img.src = btn.dataset.img;
    }
  });
})();
